// components/ProtectedRoute.jsx
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const token = localStorage.getItem("token");
  const expiry = Number(localStorage.getItem("expiry"));
  const valid = !!token && Number.isFinite(expiry) && Date.now() < expiry;

  return valid ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
